module.exports = __webpack_public_path__ + "img/licenseExample.81083e5b.png";